import {Widget} from "base/assets/js/widget/Widget.js";
import {Comm} from "base/assets/js/widget/Comm.js";
import {Comms} from "base/assets/js/widget/Comms.js";
import {CWays} from "base/assets/js/widget/CWays.js";

/**
 * навигация по времени, по комментариям
 */
export class CNavs extends Widget {

	_oData = {}; // объект для хранения исходных данных { iIndexDt: sMp }
	_iCur = null; // выделенный элемент
	_iLast = null; // самый последний элемент
	_iMarkOld = null; // отметка, последний просмотр поста пользователем
	_iMarkLast = null; // отметка, последний комментарий, на момент открытия поста
	_iDelta = 1; // сколько отображать элементов относительно выделенного элемента, и отметок _iMarkOld, _iMarkLast
	_iDeltaEnd = 3; // сколько отображать последних элементов
	_iDeltaLoad = 100; // сколько загружать за раз элементов
	_iDeltaCheck = 50; // сколько проверять
	_oNavs = {}; // объект с элемементами { iIndexDt: DOM Element }
	_bMobile;
	_iLoadNewInterval;
	_iTopicId;
	_oComms;
	_oCWays;

	run() {

		this._my( { data: 'js:_oData', cur: 'i:_iCur', "old-num": 'i:_iMarkOld', mobile: 'b:_bMobile' } );

		if( this._bMobile ) {
			// поправка на мобильные, сильно тесно там
			this._iDeltaEnd = 0;
		}

		this._render();

		this._iMarkLast = this._iLast;
		this._mod( this._oNavs[ this._iLast ], 'cnav_last', true );
		if( this._iMarkOld ) {
			this._mod( this._oNavs[ this._iMarkOld ], 'cnav_old', true );
		}

		this._refreshNav();

		// кнопки предыдущий / следующий
		this._on( 'Prev', 'click', ( oEvent ) => {
			this.select( this._iCur - 1 );
		} );
		this._on( 'Next', 'click', ( oEvent ) => {
			this.select( this._iCur + 1 );
		} );

		this.attach();
	}

	attach() {
		// добавляем interval, будет автоматом каждые 60 сек, забирать новые комментарии
		this._iLoadNewInterval = setInterval( this._wrapError( ::this._loadNew ), 60000 );
	}

	detach() {
		clearInterval( this._iLoadNewInterval );
	}

	destructor() {
		this.detach();
	}

	_loadNew() {
		this._loadData( this._iLast + 1, this._iLast + 1 + this._iDeltaLoad, true ).then( ( oData ) => {
			if( oData ) {
				this._refreshNav();
			}
		} );
	}

	/**
	 * устанавливает новый выделенный элемент, при необходимости подгружает его с сервера
	 * @param iNewCur
	 */
	select( iNewCur = null ) {

		// подгрузим этот элемент сюда Nav
		this._loadByNum( iNewCur ).then( () => {

			const sMp = this._oData[ iNewCur ];

			// после того как покажем коммент, обновляем навигацию
			this._getComms().showComment( sMp ).then( () => {

				// убираем активный до этого элемент
				if( this._iCur !== null ) {
					this._mod( this._oNavs[this._iCur], 'cnav_active', false );
				}

				this._iCur = iNewCur;
				this._refreshNav();
			} );
		} );

	}

	/**
	 * определяет какие элементы надо показывать а какие нет, и добавляет необходимые HTML class
	 */
	_refreshNav() {

		// когда активны а когда нет кнопки пред след
		this._mod( '', 'cnavs_no-prev', this._iCur === null || this._iCur === 1 );
		this._mod( '', 'cnavs_no-next', this._iCur === null || this._iCur === this._iLast );

		let bPrevShow = true;
		for( let iIndex in this._oNavs ) {
			iIndex = parseInt( iIndex );
			const bShow =
				iIndex === 1
				||
				Math.abs( iIndex - this._iCur ) <= this._iDelta
				||
				Math.abs( iIndex - this._iMarkLast ) <= this._iDelta
				||
				Math.abs( iIndex - this._iMarkOld ) <= this._iDelta
				||
				Math.abs( iIndex - this._iLast ) <= this._iDeltaEnd
			;
			const eNav = this._oNavs[ iIndex ];
			this._mod( eNav, 'cnav_hide', !bShow );
			this._mod( eNav, 'cnav_sep', false );
			if( bShow !== bPrevShow && !bShow ) {
				this._mod( this._oNavs[ iIndex - 1 ], 'cnav_sep', true );
			}
			if( this._iCur === iIndex ) {
				this._mod( eNav, 'cnav_active', true );
			}
			bPrevShow = bShow;
		}
	}

	/**
	 * по массиву  this._oData формирует DOM элементы, сохраняет в this._oNavs
	 */
	_render() {
		let iPrevIndex = null;
		const bHasEmpty = !this._iLast;
		for( let iIndex in this._oData ) {
			iIndex = parseInt( iIndex );
			if( iIndex in this._oNavs ) {
				iPrevIndex = iIndex;
				continue;
			}
			const eItem = document.createElement( 'div' );
			eItem.textContent = iIndex;
			eItem.setAttribute( 'data-mp', this._oData[iIndex] );
			eItem.setAttribute( 'class', 'cnav cnav_hide' );
			this._oNavs[iIndex] = eItem;
			this._on( eItem, 'click', () => {
				this.select( iIndex );
			} );
			if( !iPrevIndex ) {
				this._el( 'Items' ).appendChild( eItem );
			} else {
				this._oNavs[ iPrevIndex ].insertAdjacentElement('afterend', eItem );
			}
			iPrevIndex = iIndex;
		}

		if( this._iLast !== iPrevIndex ) {
			this._iLast = iPrevIndex;
			if( bHasEmpty ) {
				this._getComms().resetEmpty();
			}
		}
	}

	/**
	 * подгружает с сервера элементы
	 */
	_loadData( iFrom, iTo, bSilent = true ) {
		const oFormData = new FormData();
		oFormData.append( 'iTopicId', this._getTopicId() );
		oFormData.append( 'iFrom', iFrom );
		oFormData.append( 'iTo', iTo );
		return this.post( '/search/commentsNav', oFormData )
			.then(
				( { oNavs } ) => {
					if( oNavs ) {
						Object.assign( this._oData, oNavs );
						this._render();
						return oNavs;
					} else {
						return null;
					}
				},
				( oError ) => {
					if( bSilent ) {
						throw this.newError( {mOrigin: oError, bSkipLog: true} );
					} else {
						this.ajaxPopupCatch( oError );
					}
				}
			);
	}

	/**
	 * подгрузит указаный, и с запасом this._iDeltaLoad элементы
	 */
	_loadByNum( iNum ) {
		if( iNum > this._iLast ) {
			this._iLast = iNum;
		}
		let iFrom = this._corIndex( iNum - this._iDeltaCheck );
		let iTo = this._corIndex( iNum + this._iDeltaCheck );
		for( let i = iFrom; i <= iTo; i++ ) {
			if( typeof this._oData[ i ] !== 'undefined' ) {
				continue;
			}
			iFrom = i;
			for( let i = iTo; i >= iFrom; i-- ) {
				if( typeof this._oData[ i ] !== 'undefined' ) {
					continue;
				}
				iTo = i;
				// нужно ли вернуть Promise
				const bNeedPromise = iNum >= iFrom && iNum <= iTo;
				const oPromise = this._loadData(
					this._corIndex( iNum - this._iDeltaLoad ),
					this._corIndex( iNum + this._iDeltaLoad ),
					!bNeedPromise
				);
				if( bNeedPromise ) {
					return oPromise;
				}
				break;
			}
			break;
		}
		return Promise.resolve();
	}

	_corIndex( iIndex ) {
		if( iIndex < 1 ) {
			return 1;
		}
		if( iIndex > this._iLast ) {
			return this._iLast;
		}
		return iIndex;
	}

	/**
	 * @return {Comms}
	 */
	_getComms() {
		if( !this._oComms ) {
			this._oComms = this._rel().parent().typeOf(Comms).find();
		}
		return this._oComms;
	}
	_getCWays() {
		if( !this._oCWays ) {
			this._oCWays = this._rel( this._getComms().bl() ).child().typeOf(CWays).find();
		}
		return this._oCWays;
	}

	_getTopicId() {
		if( !this._iTopicId ) {
			this._iTopicId = this._getComms().iTopicId;
		}
		return this._iTopicId;
	}
}
